import { dataEnglishCommentSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEnglishCommentSolid = /*#__PURE__*/createIcon(dataEnglishCommentSolid)
export default IconEnglishCommentSolid
